import { Radio as RadioMantine } from '@mantine/core'
import React, { useState } from 'react'

import { PortadorasService } from '../../../../services/http/portadoras.service'
import { useGlobal } from '../../../../stores/useGlobal'
import { formatDateToGetFilter } from '../../../../utils/genericFormatters'
import MensagemInformacao from '../../../componentesModais/mensagens/mensagemInformacao'
import Botao from '../../../Mantine/Botao'
import DatePicker from '../../../Mantine/DatePicker'
import Divider from '../../../Mantine/Divider'
import Modal from '../../../Mantine/Modal'
import Radio from '../../../Mantine/Radio'

import * as S from './styles'

const OPCOES = [
  { value: '24', label: 'Últimas 24h' },
  { value: '7', label: 'Últimos 7 dias' },
  { value: '15', label: 'Últimos 15 dias' },
  { value: '30', label: 'Últimos 30 dias' },
  { value: 'periodo', label: 'Por período' }
]

const DEFAULT_DATE = {
  DE: null,
  ATE: null
}
export default function HistoricoConexoes({ opened, selecionados }) {
  const [selected, setSelected] = useState()
  const [period, setPeriod] = useState({ ...DEFAULT_DATE })
  const [alert, setAlert] = useState(false)

  const disabledConfirm =
    !selected || (selected === 'periodo' && (!period.DE || !period.ATE))

  const {
    filtros,
    busca,
    exportarRelatorio,
    setExportarRelatorio,
    setMostrarNotificacao,
    setIsLoadingGlobal
  } = useGlobal()

  const { createHistoryReport } = PortadorasService

  const handleChange = (value) => setSelected(value)

  const handleChangePeriod = (field, value) => {
    setPeriod({ ...period, [field]: value })
  }

  const handleClose = () => {
    setSelected()
    setExportarRelatorio({})
    setPeriod({ ...DEFAULT_DATE })
  }

  const handleConfirm = async () => {
    const payload = {
      tipo_arquivo: exportarRelatorio.tipo,
      arrayCdCarrier: selecionados.map((item) => item.id)
    }

    if (!filtros.vazio) {
      payload.filter = filtros
    }
    if (busca) {
      payload.fetch = busca
    }

    if (selected !== 'periodo') {
      payload.hours = selected === '24' ? 24 : Number(selected) * 24
    } else {
      payload.start = formatDateToGetFilter(period.DE)
      payload.stop = formatDateToGetFilter(period.ATE)
    }
    setIsLoadingGlobal(true)
    await createHistoryReport(payload)
      .then(() => setAlert(true))
      .catch(() => {
        setMostrarNotificacao({
          show: true,
          type: 'error',
          autoHide: 5000,
          title: 'Falha ao gerar relatório',
          message:
            'Não foi possível gerar o relatório, tente novamente mais tarde.'
        })
      })
      .finally(() => setIsLoadingGlobal(false))
  }

  if (alert) {
    return (
      <MensagemInformacao
        handleMensagemInformacao={() => {
          handleClose()
          setAlert(false)
        }}
        mensagemTitulo="Sucesso"
        mensagemParagrafo1="Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de relatórios assim que o link do mesmo estiver disponível."
        mensagemBotao="Fechar"
      />
    )
  }

  return (
    <Modal
      width="440px"
      withCloseButton={false}
      disableElipse
      titulo="Selecione o período"
      opened={opened}
      close={handleClose}
      showActionsModal={false}
    >
      <S.SubTitle>
        Selecione o período que deseja exportar seu relatório:
      </S.SubTitle>
      <RadioMantine.Group
        name="PERIODO"
        value={selected}
        onChange={handleChange}
      >
        <S.CheckboxAndRadioWrapper>
          {OPCOES?.map((opcao) => (
            <Radio key={opcao.value} value={opcao.value} label={opcao.label} />
          ))}
        </S.CheckboxAndRadioWrapper>
      </RadioMantine.Group>
      {selected === 'periodo' && (
        <S.DatePickerWrapper>
          <DatePicker
            prefixo="De:"
            value={period.DE}
            maxDate={period.ATE || new Date()}
            onChange={(date) => handleChangePeriod('DE', date)}
          />
          <DatePicker
            prefixo="Até:"
            minDate={period.DE}
            maxDate={new Date()}
            value={period.ATE}
            onChange={(date) => handleChangePeriod('ATE', date)}
          />
        </S.DatePickerWrapper>
      )}
      <Divider />
      <S.BotoesWrapper>
        <Botao label="Cancelar" variant="outline" onClick={handleClose} />
        <Botao
          disabled={disabledConfirm}
          label="Confirmar"
          variant="primary"
          onClick={handleConfirm}
        />
      </S.BotoesWrapper>
    </Modal>
  )
}
